var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40093 0.240321C1.0805 -0.0801071 0.560982 -0.0801071 0.240554 0.240321C-0.0798748 0.56075 -0.0798748 1.08027 0.240554 1.4007L1.61848 2.77862L0.240321 4.15677C-0.0801071 4.4772 -0.0801071 4.99672 0.240321 5.31715C0.56075 5.63757 1.08027 5.63757 1.4007 5.31715L2.77885 3.93899L4.10847 5.26861C4.4289 5.58904 4.94841 5.58904 5.26884 5.26861C5.58927 4.94818 5.58927 4.42866 5.26884 4.10823L3.93922 2.77862L5.26861 1.44923C5.58904 1.1288 5.58904 0.609286 5.26861 0.288858C4.94818 -0.0315707 4.42866 -0.0315707 4.10824 0.288858L2.77885 1.61824L1.40093 0.240321Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveSelection);
export default __webpack_public_path__ + "static/media/remove-selection.81b804884a324d38c0c73ac6ae8442c8.svg";
export { ForwardRef as ReactComponent };